<template>
  <div id="error-page" class="is-marginless is-paddingless has-background-solitude-grey">
    <section class="hero is-fullheight">

      <!-- Hero Body -->
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title has-text-tuna-grey">{{errorTitle}}</h1>

          <div class="columns  has-margin-bt-2">
            <div class="column"></div>
            <div class="column is-6">
              <figure>
                <img :src="errorImageUrl">
              </figure>
            </div>
            <div class="column"></div>
          </div>

          <h2 class="is-size-5 has-text-weight-light has-text-manatee-grey">{{errorText}}</h2>
          <div class="has-padding-7">
            <a class="button is-outlined is-rounded is-giada-green" href='/'>{{buttonText}}</a>
          </div>
        </div>
      </div>

      <!-- Hero Footer -->
      <div class="hero-foot">
        <nav-footer v-bind:isLanding="isLanding" v-bind:isVisible="isVisible"></nav-footer>
      </div>

      </section>
  </div>
</template>

<script>
import NavFooter from './NavFooter'

export default {
  name: 'error-body',
  data: function () {
    return {
      isVisible: false,
      isLanding: false,
      errorTitle: '',
      errorImageUrl: '',
      errorText: '',
      errorTextDictionary: {
        '403': "You tried to access a page you didn't have prior authorization for.", // 'Sorry, access to this resource on the server is denied.',
        '404': 'You may have mistyped the address, or the page may have moved.', // "Sorry, the page you're looking for cannot be accessed.",
        '500': 'We have been notified about this error and are working to fix it.' // "An error occurred and your request couldn't be completed."
      },
      errorMsgDictionary: {
        '403': 'Access Forbidden', // 'Forbidden',
        '404': 'Seems That You Got Lost', // 'Page Not Found',
        '500': 'Something Went Wrong' // 'Unexpected Error'
      },
      buttonText: 'Fly me home!'
    }
  },
  methods: {
    routingErrors: function () {
      let errorCode

      if (this.$route.params.status) {
        errorCode = this.$route.params.status === '0' ? 403 : this.$route.params.status
      } else {
        errorCode = parseInt(this.$route.params['0'].replace('/', ''))
        if (errorCode !== 403 && errorCode !== 404 && errorCode !== 500) {
          errorCode = 404
          this.$route.params['0'] = '/' + String(errorCode)
        }
      }

      this.errorTitle = this.errorMsgDictionary[String(errorCode)]
      this.errorImageUrl = require('../../assets/img/' + String(errorCode) + '.svg')
      this.errorText = this.errorTextDictionary[String(errorCode)]
    }
  },
  beforeMount () {
    this.routingErrors()
  },
  components: {
    NavFooter
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/general/ErrorPage.vue